// extracted by mini-css-extract-plugin
export default {"body":"body-BrHXq","title":"title-QVUBv","text":"text-VJ0RZ","paragraph":"paragraph-C_pQ4"};